define('models/product_image',['require','backbone'],function(require){

    var Backbone = require('backbone');

    return Backbone.Model.extend({
        url : function() {
            // set the endpoint for restful api for articles
            return this.id ? ( App.Config.apiBase + 'product-images/' + this.id + '/' ) :
                ( App.Config.apiBase + 'product-images/' );
        },

        defaults: function () {
            return {
                id: null,
                product: 0,
                image: "",
                image_width: 1,
                image_height: 1,
                image_name: ''
            };
        }
    });
});
